import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IOAuthCredential } from '../types/IOAuthCredential';

export interface IGetOAuthCredentialsResult extends IGetItemsResult {
  credentials: IOAuthCredential[];
}

export class GetOAuthCredentialsRequest extends Request<IGetItemsParams, IGetOAuthCredentialsResult> {
  constructor(params: IGetItemsParams) {
    super('getOAuthCredentials', params);
  }
}

export class GetValidOAuthCredentialsRequest extends Request<IGetItemsParams, IGetOAuthCredentialsResult> {
  constructor(params: IGetItemsParams) {
    super('getValidOAuthCredentials', params);
  }
}
